import React, { Component } from 'react'
import { VictoryAxis, VictoryChart, VictoryLegend,
  VictoryLine, VictoryScatter, VictoryTheme, VictoryGroup } from 'victory'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"

class TrackerSampleChart extends Component {
  constructor(props) {
    super(props)

    this.state = {
      checked: false,
      graph_config_status: 1,
      graph_type: 1,
      graph_data_show: 1,
      tracker_timeback: 1,
      tracker_day: [],
      tracker_week: [],
    }
  }

  componentDidMount() {
    this.getDataList()
  }

  getDataList = () => {
    var get_tracker_day = []
    var get_tracker_week = []
    // tracker day //
    this.setState({
      tracker_day: this.getSampleData1(),
      //tracker_week: get_tracker_week,
    })
    /*axios({
      method: 'post',
      url: connectNode + 'admin/patient_assessment/get_tracker_by_type3',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        uid: this.props.authReducer.uid,
        pid: this.props.match.params.pid,
        type: 1,
        tracker_timeback: this.state.tracker_timeback,
      }
    })
    .then((result) => {
      if(result['data'].length > 0) {
        get_tracker_day = result['data']
        this.setState({
          tracker_day: get_tracker_day,
        })
      }
    })
    // tracker week //
    axios({
      method: 'post',
      url: connectNode + 'admin/patient_assessment/get_tracker_by_type3',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        uid: this.props.authReducer.uid,
        pid: this.props.match.params.pid,
        type: 2,
        tracker_timeback: this.state.tracker_timeback,
      }
    })
    .then((result) => {
      if(result['data'].length > 0) {
        get_tracker_week = result['data']
        this.setState({
          tracker_week: get_tracker_week,
        })
      }
    })

    console.log(this.state)*/
  }

  normalizeValue = (value, originalMin, originalMax) => {
    if ( value === null || value === undefined || value === '' || Number(value) < originalMin ) {
      return null
    }
    const normalized = 1 + ((Number(value) - originalMin) * 4) / (originalMax - originalMin)
    return Math.round(normalized * 100) / 100
  }

  parseDate = value => {
    if (!value) {
      return null
    }

    // For API dates such as 2026-08-09T00:00:00
    if (value.indexOf('-') !== -1) {
      const datePart = value.split('T')[0]
      const parts = datePart.split('-')

      return new Date(
        Number(parts[0]),
        Number(parts[1]) - 1,
        Number(parts[2])
      )
    }

    // For sample dates such as 09/08/26
    const parts = value.split('/')

    return new Date(
      2000 + Number(parts[2]),
      Number(parts[1]) - 1,
      Number(parts[0])
    )
  }

  formatDate = value => {
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) { return '' }
    return `${date.getMonth() + 1}/${date.getDate()}`
  }

  getChartData = () => {
    return this.getTrackerSelection().data
  }

  getRecentData = (data, latestDate) => {
    if (!latestDate) { return [] }

    const cutoff = new Date(latestDate)
    cutoff.setMonth(cutoff.getMonth() - 1)

    return data
      .filter(item => {
        const date = this.parseDate(item.date)
        return date && date >= cutoff && date <= latestDate
      })
      .sort((a, b) => this.parseDate(a.date) - this.parseDate(b.date))
  }

  getTrackerSelection = () => {
    const allRows = [
      ...this.state.tracker_day,
      ...this.state.tracker_week,
    ]

    const validDates = allRows
      .map(item => this.parseDate(item.date))
      .filter(date => date && !Number.isNaN(date.getTime()))

    if (validDates.length === 0) {
      return { type: 'Daily', data: [] }
    }

    // Use the latest available tracker date as the end of the two-month window.
    const latestDate = new Date(
      Math.max(...validDates.map(date => date.getTime()))
    )
    const daily = this.getRecentData(this.state.tracker_day, latestDate)
    const weekly = this.getRecentData(this.state.tracker_week, latestDate)

    // Compare completion rates, since Daily has more possible entries than Weekly.
    const dailyCompletionRate = daily.length / 61
    const weeklyCompletionRate = weekly.length / 9

    return weeklyCompletionRate > dailyCompletionRate
      ? { type: 'Weekly', data: weekly }
      : { type: 'Daily', data: daily }
  }

  getLineData = (
    key,
    minimum,
    maximum,
    reverse = false
  ) => {
    return this.getChartData().map((item, index) => {
      const originalValue = Number(item[key])

      if (Number.isNaN(originalValue)) {
        return {
          x: index + 1,
          y: null,
        }
      }

      const convertedValue = maximum === 5 && minimum === 1
        ? originalValue
        : this.normalizeValue(originalValue, minimum, maximum)

      return {
        x: index,
        y: convertedValue,
        date: item.date,
      }
    })
  }

  getDateDomain = () => {
    const dates = this.getChartData()
      .map(row => this.parseDate(row.date))
      .filter(date => {
        return date && !Number.isNaN(date.getTime())
      })

    const today = new Date()
    today.setHours(0, 0, 0, 0)

    if (dates.length === 0) {
      const oneMonthAgo = new Date(today)
      oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1)

      return [oneMonthAgo, today]
    }

    const firstDate = new Date(
      Math.min(...dates.map(date => date.getTime()))
    )

    return [firstDate, today]
  }

  renderLine = (
    key,
    color,
    minimum,
    maximum,
    reverse = false
  ) => {
    const data = this.getLineData(
      key,
      minimum,
      maximum,
      reverse
    )

    return (
      <VictoryGroup
        key={key}
        data={data}
        color={color}
      >
        <VictoryLine
          data={data}
          style={{
            data: {
              stroke: color,
              strokeWidth: 1,
            },
          }}
        />

        <VictoryScatter
          data={data}
          size={1.5}
          style={{
            data: {
              fill: color,
            },
          }}
        />
      </VictoryGroup>
    )
  }

  getXAxisTicks = () => {
    const data = this.getChartData()

    if (data.length === 0) {
      return []
    }

    const maximumLabels = 12

    const interval = Math.max(
      1,
      Math.ceil(
        data.length / maximumLabels
      )
    )

    const ticks = []

    for (
      let index = 0;
      index < data.length;
      index += interval
    ) {
      ticks.push(index)
    }

    const lastIndex = data.length - 1

    if (
      ticks[ticks.length - 1] !==
      lastIndex
    ) {
      ticks.push(lastIndex)
    }

    return ticks
  }

  formatXAxisDate = index => {
    const data = this.getChartData()
    const row = data[index]

    if (!row) {
      return ''
    }

    const date = this.parseDate(row.date)

    if (
      !date ||
      Number.isNaN(date.getTime())
    ) {
      return row.date
    }

    return `${
      date.getMonth() + 1
    }/${date.getDate()}`
  }

  getSampleData1 = () => {
    const sampleData = [
      { date: '16/05/26', mood_manic: 1, mood_depressed: 4.5, sleep: 3, medication: 3, exercise: 1, anxiety: 2.5 },
      { date: '18/05/26', mood_manic: 1, mood_depressed: 2, sleep: 3, medication: 5, exercise: 1, anxiety: 1.5 },
      { date: '19/05/26', mood_manic: 1.5, mood_depressed: 4.5, sleep: 4, medication: 5, exercise: 4, anxiety: 2 },
      { date: '21/05/26', mood_manic: 1, mood_depressed: 2, sleep: 3.5, medication: 5, exercise: 8, anxiety: 2 },
      { date: '22/05/26', mood_manic: 1, mood_depressed: 3, sleep: 3.5, medication: 3, exercise: 8, anxiety: 2.5 },
      { date: '23/05/26', mood_manic: 1, mood_depressed: 3.5, sleep: 2.5, medication: 5, exercise: 7, anxiety: 1.5 },
      { date: '24/05/26', mood_manic: 1, mood_depressed: 3.5, sleep: 4, medication: 5, exercise: 3.5, anxiety: 2 },
      { date: '25/05/26', mood_manic: 1, mood_depressed: 3.5, sleep: 3.5, medication: 5, exercise: 4.5, anxiety: 1 },
      { date: '26/05/26', mood_manic: 1, mood_depressed: 3, sleep: 5, medication: 5, exercise: 8, anxiety: 1 },
      { date: '27/05/26', mood_manic: 1, mood_depressed: 3.5, sleep: 5, medication: 5, exercise: 6, anxiety: 2.5 },
      { date: '28/05/26', mood_manic: 1, mood_depressed: 3.5, sleep: 3.5, medication: 5, exercise: 8, anxiety: 2 },
      { date: '29/05/26', mood_manic: 1, mood_depressed: 4, sleep: 3.5, medication: 5, exercise: 6, anxiety: 2.5 },
      { date: '30/05/26', mood_manic: 1, mood_depressed: 4, sleep: 4, medication: 5, exercise: 1, anxiety: 2.5 },
      { date: '31/05/26', mood_manic: 1, mood_depressed: 4, sleep: 4, medication: 5, exercise: 1, anxiety: 2 },

      { date: '01/06/26', mood_manic: 1, mood_depressed: 3.5, sleep: 5, medication: 5, exercise: 1, anxiety: 1.5 },
      { date: '02/06/26', mood_manic: 1, mood_depressed: 2, sleep: 3.5, medication: 5, exercise: 4, anxiety: 2.5 },
      { date: '03/06/26', mood_manic: 1, mood_depressed: 4.5, sleep: 3.5, medication: 5, exercise: 1, anxiety: 1.5 },
      { date: '04/06/26', mood_manic: 1, mood_depressed: 4.5, sleep: 3.5, medication: 3, exercise: 6.5, anxiety: 1.5 },
      { date: '05/06/26', mood_manic: 1.5, mood_depressed: 4, sleep: 3.5, medication: 5, exercise: 4.5, anxiety: 1.5 },
      { date: '06/06/26', mood_manic: 1, mood_depressed: 3.5, sleep: 3.5, medication: 5, exercise: 3.5, anxiety: 1.5 },
      { date: '07/06/26', mood_manic: 1, mood_depressed: 4, sleep: 4, medication: 5, exercise: 1, anxiety: 2 },
      { date: '08/06/26', mood_manic: 1, mood_depressed: 4, sleep: 3.5, medication: 5, exercise: 1, anxiety: 1 },
      { date: '09/06/26', mood_manic: 1, mood_depressed: 3.5, sleep: 3.5, medication: 5, exercise: 8, anxiety: 1.5 },
      { date: '10/06/26', mood_manic: 1, mood_depressed: 3.5, sleep: 4.5, medication: 5, exercise: 1, anxiety: 2 },
      { date: '11/06/26', mood_manic: 1, mood_depressed: 3.5, sleep: 3.5, medication: 5, exercise: 1, anxiety: 2 },
      { date: '12/06/26', mood_manic: 1, mood_depressed: 3.5, sleep: 3.5, medication: 5, exercise: 3, anxiety: 1.5 },
      { date: '13/06/26', mood_manic: 1, mood_depressed: 4.5, sleep: 3.5, medication: 5, exercise: 1, anxiety: 1.5 },
      { date: '14/06/26', mood_manic: 1, mood_depressed: 4.5, sleep: 5, medication: 5, exercise: 1, anxiety: 2 },
      { date: '15/06/26', mood_manic: 1, mood_depressed: 4.5, sleep: 3.5, medication: 5, exercise: 1, anxiety: 1.5 },
      { date: '16/06/26', mood_manic: 1, mood_depressed: 4, sleep: 4, medication: 5, exercise: 1, anxiety: 2 },
      { date: '17/06/26', mood_manic: 1, mood_depressed: 3, sleep: 3.5, medication: 5, exercise: 8, anxiety: 1 },
      { date: '18/06/26', mood_manic: 1, mood_depressed: 4.5, sleep: 4.5, medication: 5, exercise: 8, anxiety: 1.5 },
      { date: '19/06/26', mood_manic: 1, mood_depressed: 4, sleep: 3, medication: 5, exercise: 6, anxiety: 1.5 },
      { date: '20/06/26', mood_manic: 1, mood_depressed: 4.5, sleep: 4, medication: 5, exercise: 1, anxiety: 2 },
      { date: '21/06/26', mood_manic: 1, mood_depressed: 2.5, sleep: 3.5, medication: 5, exercise: 8, anxiety: 1 },
      { date: '23/06/26', mood_manic: 1, mood_depressed: 3.5, sleep: 3, medication: 3, exercise: 1, anxiety: 2 },
      { date: '24/06/26', mood_manic: 1, mood_depressed: 5, sleep: 2.5, medication: 3, exercise: 1, anxiety: 2 },
      { date: '25/06/26', mood_manic: 1, mood_depressed: 4.5, sleep: 3.5, medication: 5, exercise: 1, anxiety: 1 },
      { date: '29/06/26', mood_manic: 1, mood_depressed: 4.5, sleep: 4, medication: 5, exercise: 8, anxiety: 2 },
      { date: '30/06/26', mood_manic: 1, mood_depressed: 4.5, sleep: 4, medication: 5, exercise: 1, anxiety: 2.5 },

      { date: '01/07/26', mood_manic: 1, mood_depressed: 4, sleep: 4.5, medication: 5, exercise: 1, anxiety: 2 },
      { date: '02/07/26', mood_manic: 1, mood_depressed: 4, sleep: 3.5, medication: 3, exercise: 8, anxiety: 1.5 },
      { date: '04/07/26', mood_manic: 1, mood_depressed: 5, sleep: 3, medication: 5, exercise: 6, anxiety: 2 },
      { date: '05/07/26', mood_manic: 1, mood_depressed: 4, sleep: 2, medication: 3, exercise: 5.5, anxiety: 1.5 },
      { date: '06/07/26', mood_manic: 1, mood_depressed: 4.5, sleep: 5, medication: 5, exercise: 1, anxiety: 1.5 },
      { date: '07/07/26', mood_manic: 1, mood_depressed: 2, sleep: 3.5, medication: 5, exercise: 1, anxiety: 1.5 },
      { date: '08/07/26', mood_manic: 1, mood_depressed: 3, sleep: 4, medication: 5, exercise: 1, anxiety: 1.5 },
      { date: '09/07/26', mood_manic: 1, mood_depressed: 3, sleep: 3, medication: 5, exercise: 3.5, anxiety: 1.5 },
      { date: '10/07/26', mood_manic: 1, mood_depressed: 4, sleep: 2, medication: 5, exercise: 1, anxiety: 2 },
      { date: '11/07/26', mood_manic: 1, mood_depressed: 4.5, sleep: 3.5, medication: 5, exercise: 4.5, anxiety: 1.5 },
      { date: '12/07/26', mood_manic: 1, mood_depressed: 4, sleep: 2, medication: 3, exercise: 1, anxiety: 1 },
      { date: '13/07/26', mood_manic: 1, mood_depressed: 4.5, sleep: 5, medication: 5, exercise: 1, anxiety: 2 },
      { date: '14/07/26', mood_manic: 1, mood_depressed: 3, sleep: 3, medication: 5, exercise: 8, anxiety: 1 },
      { date: '20/07/26', mood_manic: 1, mood_depressed: 3.5, sleep: 3, medication: 5, exercise: 1, anxiety: 1.5 },
      { date: '21/07/26', mood_manic: 1, mood_depressed: 3.5, sleep: 4, medication: 3, exercise: 4, anxiety: 2 },
      { date: '30/07/26', mood_manic: 1, mood_depressed: 4.5, sleep: 4.5, medication: 5, exercise: 1, anxiety: 1 },
      { date: '31/07/26', mood_manic: 1, mood_depressed: 4.5, sleep: 4, medication: 5, exercise: 1, anxiety: 1.5 },

      { date: '02/08/26', mood_manic: 1, mood_depressed: 4.5, sleep: 4.5, medication: 5, exercise: 1, anxiety: 1 },
      { date: '03/08/26', mood_manic: 1, mood_depressed: 4, sleep: 5, medication: 5, exercise: 8, anxiety: 1 },
      { date: '04/08/26', mood_manic: 1, mood_depressed: 4, sleep: 3.5, medication: 5, exercise: 8, anxiety: 2 },
      { date: '05/08/26', mood_manic: 1, mood_depressed: 4.5, sleep: 4, medication: 3, exercise: 1, anxiety: 1.5 },
      { date: '06/08/26', mood_manic: 1, mood_depressed: 4.5, sleep: 5.5, medication: 5, exercise: 1, anxiety: 2 },
      { date: '07/08/26', mood_manic: 1, mood_depressed: 5, sleep: 4.5, medication: 5, exercise: 1, anxiety: 1 },
      { date: '08/08/26', mood_manic: 1, mood_depressed: 4.5, sleep: 4.5, medication: 3, exercise: 1, anxiety: 1 },
      { date: '09/08/26', mood_manic: 1, mood_depressed: 4.5, sleep: 3.5, medication: 5, exercise: 1, anxiety: 2 },
    ]

    return sampleData
  }
  renderTrackerChart = (title, lines) => {
    const chartData = this.getChartData()
    const xAxisTicks = this.getXAxisTicks()

    return (
      <div style={{ marginBottom: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 1 }}>
          {title}
        </div>

        <VictoryChart
          theme={VictoryTheme.material}
          height={130}
          padding={{ top: 32, bottom: 38, left: 38, right: 20 }}
          domain={{
            x: [0, Math.max(chartData.length - 1, 1)],
            y: [0.7, 5.3],
          }}
          domainPadding={{ x: 5 }}
        >
          <VictoryLegend
            x={55}
            y={5}
            orientation="horizontal"
            gutter={18}
            style={{ labels: { fontSize: 7 } }}
            data={lines.map(line => ({
              name: line.label,
              symbol: { fill: line.color },
            }))}
          />

          <VictoryAxis
            tickValues={xAxisTicks}
            tickFormat={index => this.formatXAxisDate(index)}
            style={{
              axis: { stroke: '#cccccc' },
              grid: { stroke: '#eeeeee', strokeDasharray: '4,4' },
              ticks: { stroke: '#cccccc', size: 2 },
              tickLabels: {
                fontSize: 6,
                padding: 3,
                angle: -45,
                textAnchor: 'end',
              },
            }}
          />

          <VictoryAxis
            dependentAxis
            tickValues={[1, 2, 3, 4, 5]}
            label="Relative score"
            style={{
              axis: { stroke: '#cccccc' },
              axisLabel: { fontSize: 7, padding: 30 },
              grid: { stroke: '#eeeeee', strokeDasharray: '4,4' },
              ticks: { stroke: '#cccccc', size: 2 },
              tickLabels: { fontSize: 6, padding: 4 },
            }}
          />

          {lines.map(line => this.renderLine(
            line.key,
            line.color,
            line.minimum,
            line.maximum
          ))}
        </VictoryChart>
      </div>
    )
  }

  render() {
    const selection = this.getTrackerSelection()
    const chartData = selection.data

    if (chartData.length === 0) {
      return (
        <div className="small-12 columns">
          Not enough tracker information to display a trend.
        </div>
      )
    }

    const firstDate = this.formatDate(this.parseDate(chartData[0].date))
    const lastDate = this.formatDate(
      this.parseDate(chartData[chartData.length - 1].date)
    )

    const moodLines = [
      { key: 'mood_manic', label: 'Mania', color: '#00acc1', minimum: 1, maximum: 5 },
      { key: 'mood_depressed', label: 'Depression', color: '#7e57c2', minimum: 1, maximum: 5 },
      { key: 'anxiety', label: 'Anxiety', color: '#d81b60', minimum: 1, maximum: 5 },
    ]

    const routineLines = [
      { key: 'sleep', label: 'Sleep', color: '#1e88e5', minimum: 1, maximum: 7 },
      { key: 'exercise', label: 'Exercise', color: '#fb8c00', minimum: 1, maximum: 8 },
      { key: 'medication', label: 'Medication', color: '#43a047', minimum: 1, maximum: 5 },
    ]

    return (
      <div className="small-12 columns">
        <div className="title6">Daily Trackers</div>

        {this.renderTrackerChart('Mood and Anxiety', moodLines)}
        {this.renderTrackerChart(
          'Sleep, Exercise, and Medication',
          routineLines
        )}
      </div>
    )
  }

}

const mapStateToProps = (state) => {
  //console.log('Dashboard STATE: ', state)
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    //console.log('Dashboard mapDispatchToProps')
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(TrackerSampleChart)
